import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useVagasNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/vagas/processosencerrados/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/vagas/processosencerrados/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/vagas/processosencerrados/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
